import {Component, OnInit, HostListener, OnDestroy} from "@angular/core";
import {MatDialog, MAT_DIALOG_DATA} from "@angular/material";
import {AddLeadDialogComponent} from "../../../shared/add-lead-dialog/add-lead-dialog.component";
import {
  AdminService,
  CommonService,
  LeadService,
  AlertService,
  ProfileService,
  ProjectService,
} from "../../../_services/";
import {ActivatedRoute} from "@angular/router";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  FormArray,
  Validators,
  Form,
} from "@angular/forms";
import {
  emailList,
  signInEmailList,
  filterEmailList,
} from "../../../_helper/global";

import {EditContactDialogComponent} from "../edit-contact-dialog/edit-contact-dialog.component";
import {AddProjectDialogComponent} from "../../../shared/add-project-dialog/add-project-dialog.component";

import {AddAppointmentDialogComponent} from "../../../shared/add-appointment-dialog/add-appointment-dialog.component";
import {AddReminderDialogComponent} from "../../../shared/add-reminder-dialog/add-reminder-dialog.component";
import {AddNoteDialogComponent} from "../../../shared/add-note-dialog/add-note-dialog.component";
import {environment} from "../../../../environments/environment";
import {Subscription} from "rxjs";
import {AngularFirestore} from "@angular/fire/firestore";
import {AngularFireFunctions} from "@angular/fire/functions";

import * as moment from "moment";
import * as XLSX from "xlsx";
import {ToastrService} from "ngx-toastr";

// For the search only version
import algoliasearch from "algoliasearch";
import {EditReminderDialogComponent} from "src/app/shared/edit-reminder-dialog/edit-reminder-dialog.component";

const client = algoliasearch(
  environment.algolia.appId,
  environment.algolia.adminAPIKey
);
const index = client.initIndex("contacts");
const index2 = client.initIndex("projects");

@Component({
  selector: "app-contacts-list",
  templateUrl: "./contacts-list.component.html",
  styleUrls: ["./contacts-list.component.scss"],
  providers: [AngularFireFunctions],
})
export class ContactsListComponent implements OnInit {
  filterForm: FormGroup;
  searchForm: FormGroup;

  panelOpenState = false;
  contactList: any[] = [];
  contactList2: any[] = [];
  excelArray: any[] = [];
  fileName = "Leads.xlsx";
  successMsg: any;
  errMsg: any;
  searchAreaStatus = true;
  contactType: String = "";
  jobFunctionList: any[] = [];
  headingLabel: String = "";
  addLabel: String = "";
  appointmentList: any[] = [];
  reminderList: any[] = [];
  noteList: any[] = [];
  designerList: any[] = [];
  contactSourceList: any[] = [];
  showrooms: any;
  showFilter: Boolean = false;
  limit: any = 10;
  totalContacts: Number = 11;
  searchContactIds: String[] = [];
  paginationClickedCount: Number = 0;
  prevStartAt: [] = [];
  disableNext: Boolean = false;
  disablePrev: Boolean = false;
  contactListExcel: any[];

  firstInResponse: any = []; //Save first document in snapshot of items received
  lastInResponse: any = []; //Save last document in snapshot of items received

  //Keep the array of first document of previous pages
  prev_strt_at: any = [];
  //Maintain the count of clicks on Next Prev button
  pagination_clicked_count = 0;
  //Disable next and prev buttons
  disable_next: boolean = false;
  disable_prev: boolean = false;
  currentItem: any = {};
  clientList: any[] = [];
  clientProjectList: any[] = [];
  isDesigner: Boolean;
  isLoading: Boolean;
  allRecordFetched = false;
  pageCounter = 0;
  currentContactId: string;
  subscription: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;
  subscription4: Subscription;
  subscription5: Subscription;
  subscription6: Subscription;
  subscription7: Subscription;
  subscription8: Subscription;
  subscription9: Subscription;
  subscription10: Subscription;
  subscription11: Subscription;
  subscription12: Subscription;
  subscription13: Subscription;
  subscription14: Subscription;
  signInVisible: Boolean;
  showShareForm = false;
  searchContacts: any[] = [];
  shareForm: FormGroup;
  shareRecord: any;

  constructor(
    public dialog: MatDialog,
    private _common: CommonService,
    public _admin: AdminService,
    public _lead: LeadService,
    private _alert: AlertService,
    private _profile: ProfileService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private _toastr: ToastrService,
    private _project: ProjectService,
    private firestore: AngularFirestore,
    private fns: AngularFireFunctions
  ) {}

  ngOnInit() {
    this.isDesigner = emailList.includes(localStorage.getItem("rs-email"))
      ? false
      : true;
    this.signInVisible = signInEmailList.includes(
      localStorage.getItem("rs-email")
    )
      ? true
      : false;
    // this.searchForm = this.fb.group({
    //   owner_contact_id:['',[]],
    //   contact_source_id:['',[]],
    //   showroom:['',[]]
    // })

    this.filterForm = this.fb.group({
      owner_contact_id: ["", []],
      showroom: ["", []],
      contact_source_id: ["", []],
      start_date: ["", []],
      end_date: ["", []],
    });

    this._profile.contactTypeTitle.subscribe((title) => {
      this.headingLabel = title;
      if (this.headingLabel.charAt(this.headingLabel.length - 1) == "s") {
        this.addLabel = this.headingLabel.substring(
          0,
          this.headingLabel.length - 1
        );
      }
    });

    // Get contact type from url...
    this.route.paramMap.subscribe((params) => {
      this.contactType = params.get("contactType");
      if (this.signInVisible === false && this.contactType === "signin") {
        this._common.navigate("contacts");
      }
    });
    this.route.params.subscribe((routeParams) => {
      this.getContactList();

      if (this.headingLabel == "Contacts") {
        this.headingLabel =
          this.contactType != null
            ? this.capitalizeString(this.contactType.replace(/_/g, " "))
            : "Contacts";
      }
      if (this.headingLabel.charAt(this.headingLabel.length - 1) == "s") {
        this.addLabel = this.headingLabel.substring(
          0,
          this.headingLabel.length - 1
        );
      } else {
        this.addLabel = this.headingLabel;
      }
    });

    this._profile.leadSearchArea.subscribe((status) => {
      // this.searchAreaStatus = status['show'];
    });
    this.getJobFunctionList();
    this.getDesignerList();
    this.getcontactSourceList();
    this.getShowroomList();
    this.shareForm = this.fb.group({
      keyword: ["", []],
      recipient_contact_id: ["", []],
      message: ["", []],
    });
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  capitalizeString(string) {
    return string
      .split(" ")
      .map((item) => item.replace(item.charAt(0), item.charAt(0).toUpperCase()))
      .join(" ");
  }

  @HostListener("window:scroll", [])
  onScroll(): void {
    if (window.innerHeight + window.scrollY >= document.body.scrollHeight) {
      // offsetHeight
      if (this.isLoading === false && this.allRecordFetched === false) {
        this.nextPage();
      }
    }
  }

  openEditReminderDilaog(id) {
    this.successMsg = "";
    this.errMsg = "";
    this.dialog.open(EditReminderDialogComponent, {
      width: "auto",
      data: {
        reminder_id: id,
      },
    });
  }

  exportexcel(): void {
    this._common.showLoader(true);
    this.contactListExcel = [];
    this.excelArray = [];
    /* table id is passed over here */
    //  let element = document.getElementById('lead-listing');
    const listType = emailList.includes(localStorage.getItem("rs-email"))
      ? "all"
      : "filtered";
    this._lead
      .exportContactList(
        listType,
        this.contactType,
        this.filterForm.value,
        this.isDesigner,
        localStorage.getItem("uid"),
        []
      )
      .then((res: any) => {
        //
        res.subscribe((resp) => {
          this.contactListExcel = resp.docs;

          for (let i = 0; i < this.contactListExcel.length; i++) {
            const item = this.contactListExcel[i].data();
            let obj = {};
            obj["first_name"] = item.first_name;
            obj["last_name"] = item.last_name;
            obj["address"] = item.address;
            obj["designer"] = `${
              item.owner_first_name ? item.owner_first_name : ""
            } ${item.owner_last_name ? item.owner_last_name : ""}`;
            obj["phone"] = item.mobile_phone;
            obj["email"] = item.email;
            obj["date_created"] = new Date(item.date_created);
            this.excelArray.push(obj);
          }

          const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.excelArray);

          /* generate workbook and add the worksheet */
          const wb: XLSX.WorkBook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
          /* save to file */
          XLSX.writeFile(wb, this.fileName);
          this._common.showLoader(false);
        });
      });
  }

  toggleShareForm() {
    this.showShareForm = !this.showShareForm;
  }

  // Search Algolia...
  searchAlgolia(form) {
    this.searchContactIds = [];
    this.searchContacts = [];
    const requestOptions = {
      headers: {},
    };
    console.log(form.value.keyword, "form.value.keyword");
    // Search Contacts...
    index.search(form.value.keyword, requestOptions).then(({hits}) => {
      if (form.value.keyword != "") {
        this.searchContacts = [];
        hits.forEach((item: any) => {
          if (item.contact_type_id == "staff") {
            this.searchContacts.push({
              owner_first_name: item["owner_first_name"],
              owner_last_name: item["owner_last_name"],
              first_name: item["first_name"],
              last_name: item["last_name"],
              mobile_phone: item["mobile_phone"],
              email: item["email"],
              objectID: item["objectID"],
            });
          }
        });
      }
    });
  }

  onFormSubmit(): void {
    this.errMsg = "";
    this.successMsg = "";
    if (this.shareForm.invalid) {
      return;
    }
    let form = this.shareForm.value;
    const obj = {
      sender_contact_id: localStorage.getItem("contactId"),
      recipient_contact_id: form.recipient_contact_id,
      record_id: this.currentContactId,
      comment: form.message,
      record_type: "contact",
    };
    if (window.location.host.includes("localhost")) {
      this.fns.functions.useFunctionsEmulator("http://localhost:5000");
    }
    this._common.showLoader(true);
    const recordShare = this.fns.httpsCallable("record_share");
    recordShare(obj).subscribe(
      (result) => {
        this._common.showLoader(false);
        if (result.outcome === "success") {
          this.shareForm.reset();
          this.successMsg = result.message;
          this.showShareForm = false;
        } else {
          this.errMsg = result.message;
        }
      },
      (err) => {
        this.errMsg =
          err && err.message ? err.message : "Something went wrong!";
      }
    );
  }

  selectContact(item) {
    let fullName = item.first_name + " " + item.last_name;
    this.shareForm.patchValue({
      keyword: fullName,
      recipient_contact_id: item.objectID,
    });

    this.searchContacts = [];
  }

  getContactList(searchContactIds = []) {
    const listType = emailList.includes(localStorage.getItem("rs-email"))
      ? "all"
      : "filtered";
    this.errMsg = "";
    this._common.showLoader(true);
    this.isLoading = true;
    this.contactList = [];
    this.subscription = this._lead
      .getContactList(
        listType,
        this.contactType,
        this.filterForm.value,
        this.limit,
        this.isDesigner,
        localStorage.getItem("uid"),
        searchContactIds
      )
      .subscribe(
        (res) => {
          this._common.showLoader(false);
          // console.log(res.docs, "res.docs!!!!");
          if (res.docs.length === 0) {
            this.allRecordFetched = true;
          } else {
            // this.firstInResponse = res[0].payload.doc;
            // this.lastInResponse = res[res.length - 1].payload.doc;
            this.firstInResponse = res.docs[0];
            this.lastInResponse = res.docs[res.docs.length - 1];
          }
          for (let item of res.docs) {
            // this.contactList.push(item.payload.doc.data());
            this.contactList.push(item.data());
          }
          //Initialize values
          this.prev_strt_at = [];
          this.pagination_clicked_count = 0;
          this.disable_next = false;
          this.disable_prev = false;
          //Push first item to use for Previous action
          this.push_prev_startAt(this.firstInResponse);

          this.isLoading = false;
          if (window.screen.height > 900) {
            this.nextPage();
          }
          /*
      const clientData = res.filter(item=> item.payload.doc.data()["contact_type_id"]=="client" || item.payload.doc.data()["contact_type_id"]=="lead");
      const contactIdAll = res.map(item=> item.payload.doc.data()['id']);
      this.clientList = clientData.map(item=> item.payload.doc.data()['id']);
      const testRec = res.map(item=> item.payload.doc.data());
      
      // Fetch list of projects for client && leads
      const clientList2  = this.clientList.filter(elm => elm);
      
      this._admin.getClientProjectList(clientList2).subscribe(result=>{
        this.clientProjectList = result.map(item=> item.payload.doc.data());
     
      
          // Load project Appointments...
          for (let k=0;k<this.contactList.length;k++){
            // Push client project list
            const currentContactProject = this.clientProjectList.filter(item=>item.contact_id==this.contactList[k].id);
            this.contactList[k].projects = currentContactProject;
          }
  */
          // Load Appointments...
          /* this._lead.getAppointmentList({contactId: contactIdAll}).subscribe(result=>{
        
            this.appointmentList = result;
            for (let k=0;k<this.contactList.length;k++){
                // bind appointment list with contact list
                let contactAppointment = [];
                  
                for(let l=0; l<this.appointmentList.length;l++){
                  if(this.appointmentList[l].payload.doc.data().contact_id!==null && this.appointmentList[l].payload.doc.data().contact_id == this.contactList[k].id){
                    contactAppointment.push(this.appointmentList[l].payload.doc.data());            
                  }
                }
                
                this.contactList[k].appointmentList = contactAppointment;
            }
          },err=>{
            this.isLoading = false;
            this._common.showLoader(false);
            this._alert.error(err.error && err.error.message?err.error.message:'Something went wrong!');
          }) */

          // fetch reminder list...
          /*  this._lead.getReminderList({contactId: contactIdAll}).subscribe(result2=>{
              this.reminderList = result2;
              for (let k=0;k<this.contactList.length;k++){
                
                
                //bind reminder list with contct list
                let contactReminder = [];
                for(let l=0; l<this.reminderList.length;l++){
                  if(this.reminderList[l].payload.doc.data().contact_id!==null && this.reminderList[l].payload.doc.data().contact_id == this.contactList[k].id){
                    contactReminder.push(this.reminderList[l].payload.doc.data());            
                  }
                }
                this.contactList[k].reminderList = contactReminder;
              }

            },err=>{
              this.isLoading = false;
              this._common.showLoader(false);
              this._alert.error(err.error && err.error.message?err.error.message:'Something went wrong!');
            }) */
          // fetch notes list...
          /* this._lead.getNotesList({contactId: contactIdAll}).subscribe(result3=>{
                this._common.showLoader(false);
                this.noteList = result3;
                
                for (let k=0;k<this.contactList.length;k++){
                
                  //bind notes list with contct list
                  let contactNotes = [];
                  for(let m=0; m<this.noteList.length;m++){
                    if(this.noteList[m].payload.doc.data().contact_id!==null && this.noteList[m].payload.doc.data().contact_id == this.contactList[k].id){
                      contactNotes.push(this.noteList[m].payload.doc.data());            
                    }
                  }
                  this.contactList[k].notesList = contactNotes;
                }
                
              
              },err=>{
                this.isLoading = false;
                this._common.showLoader(false);
                this._alert.error(err.error && err.error.message?err.error.message:'Something went wrong!');
              }) */

          /*      },err=>{
        this.isLoading = false;
        this._common.showLoader(false);
        this._alert.error(err.error && err.error.message?err.error.message:'Something went wrong!');
      }) */
        },
        (error) => {
          console.error(error, "error!!!");
          this.isLoading = false;
          this._alert.error("Something went wrong!");
        }
      );
  }

  //Add document
  push_prev_startAt(prev_first_doc) {
    this.prev_strt_at.push(prev_first_doc);
  }

  //Show previous set
  /*
  prevPage() {
    this.errMsg = "";
    this.disable_prev = true;
    this._lead.getPreContactList(this.contactType, this.filterForm.value, this.limit, this.isDesigner,localStorage.getItem('uid'), this.get_prev_startAt(), this.firstInResponse, this.searchContactIds).subscribe(res => {
      this.firstInResponse = res.docs[0];
      this.lastInResponse = res.docs[res.docs.length - 1];

      this.contactList = [];
        for (let item of res.docs) {
          this.contactList.push(item.data());
        }
        
        const clientData = this.contactList.filter(item=> item["contact_type_id"]=="client");
        this.clientList = clientData.map(item=> item.contact_id);
        const clientList2  = this.clientList.filter(elm => elm);
        this._admin.getClientProjectList(this.clientList).subscribe(result=>{
          this.clientProjectList = result.map(item=> item.payload.doc.data());
          // fetch appointment list
          this._lead.getAppointmentList({contactId: clientList2}).subscribe(result=>{
            this.appointmentList = result;
            // fetch reminder list...
            this._lead.getReminderList({contactId: clientList2}).subscribe(result2=>{
              this.reminderList = result2;
              // fetch notes list...
              this._lead.getNotesList({contactId: clientList2}).subscribe(result3=>{
                this._common.showLoader(false);              

                this.noteList = result3;
                for (let k=0;k<this.contactList.length;k++){
                  // Push client project list
                  const currentContactProject = this.clientProjectList.filter(item=>item.contact_id==this.contactList[k].contact_id);
                  this.contactList[k].projects = currentContactProject;

                  // bind appointment list with contact list
                  let contactAppointment = [];
                  for(let l=0; l<this.appointmentList.length;l++){
                    if(this.appointmentList[l].payload.doc.data().contact_id!==null && this.appointmentList[l].payload.doc.data().contact_id == this.contactList[k].id){
                      contactAppointment.push(this.appointmentList[l].payload.doc.data());            
                    }
                  }
                  // obj.appointmentList = contactAppointment;
                  this.contactList[k].appointmentList = contactAppointment;
                  //bind reminder list with contct list
                  let contactReminder = [];
                  for(let l=0; l<this.reminderList.length;l++){
                    if(this.reminderList[l].payload.doc.data().contact_id!==null && this.reminderList[l].payload.doc.data().contact_id == this.contactList[k].id){
                      contactReminder.push(this.reminderList[l].payload.doc.data());            
                    }
                  }
                  // obj.reminderList = contactReminder;
                  this.contactList[k].reminderList = contactReminder;
                  //bind notes list with contct list
                  let contactNotes = [];
                  for(let m=0; m<this.noteList.length;m++){
                    if(this.noteList[m].payload.doc.data().contact_id!=null && this.noteList[m].payload.doc.data().contact_id == this.contactList[k].id){
                      contactNotes.push(this.noteList[m].payload.doc.data());            
                    }
                  }
                  // obj.notesList = contactNotes;
                  this.contactList[k].notesList = contactNotes;
                }
                
              },err=>{
                
                this._common.showLoader(false);
                this._alert.error(err.error && err.error.message?err.error.message:'Something went wrong!');
              })

            },err=>{
              
              this._common.showLoader(false);
              this._alert.error(err.error && err.error.message?err.error.message:'Something went wrong!');
            })
          

          },err=>{
            this._common.showLoader(false);
            this._alert.error(err.error && err.error.message?err.error.message:'Something went wrong!');
          })
          
        },err=>{
          this._common.showLoader(false);
          this._alert.error(err.error && err.error.message?err.error.message:'Something went wrong!');
        })

    
      //Maintaing page no.
      this.pagination_clicked_count--;

      //Pop not required value in array
      this.pop_prev_startAt(this.firstInResponse);

      //Enable buttons again
      this.disable_prev = false;
      // if(this.totalContacts<=(this.pagination_clicked_count+1)*this.limit){
      //   this.disable_next = true;  
      // }
      // else{
      //   this.disable_next = false;
      // }
      this.disable_next = false;
    }, error => {
      this.disable_prev = false;
    });
  } */

  // get next record
  nextPage() {
    if (this.isLoading === false) {
      const listType = emailList.includes(localStorage.getItem("rs-email"))
        ? "all"
        : "filtered";
      this.isLoading = true;
      this.pageCounter += 1;
      this.errMsg = "";
      // this.disable_next = true;
      this._lead
        .getNextContactList(
          listType,
          this.contactType,
          this.filterForm.value,
          this.limit,
          this.isDesigner,
          localStorage.getItem("uid"),
          this.lastInResponse,
          this.searchContactIds
        )
        .subscribe(
          (res) => {
            if (!res.docs.length) {
              this.allRecordFetched = true;
              this.disable_next = true;
              return;
            }

            this.firstInResponse = res.docs[0];
            this.lastInResponse = res.docs[res.docs.length - 1];
            this.isLoading = false;
            for (let item of res.docs) {
              this.contactList.push(item.data());
            }

            /*    this.contactList2 = [];
          // let tempContactList=[];
            for (let item of res.docs) {
              // tempContactList.push(item.data()); 
              this.contactList2.push(item.data());
              // this.contactList.push(item.data());
            }
            const clientData = this.contactList2.filter(item=> item["contact_type_id"]=="client");
          
            const contactIdAll = this.contactList2.map(item=> item['id']);
            
            this.clientList = clientData.map(item=> item.id);
            const clientList2  = this.clientList.filter(elm => elm);
            
          // Fetch list of projects for client
          
          this._admin.getClientProjectList(this.clientList).subscribe(result=>{
            this.clientProjectList = result.map(item=> item.payload.doc.data()); */

            // Load Appointment Reminder Notes...
            /*this._lead.getAppointmentList({contactId: contactIdAll}).subscribe(result=>{
        
              this.appointmentList = result;
              for (let k=0;k<this.contactList2.length;k++){
                // Push client project list
                
                const currentContactProject = this.clientProjectList.filter(item=>item.contact_id==this.contactList2[k].id);
                this.contactList[k].projects = currentContactProject;
                // bind appointment list with contact list
                let contactAppointment = [];
                
                for(let l=0; l<this.appointmentList.length;l++){
                  if(this.appointmentList[l].payload.doc.data().contact_id!==null && this.appointmentList[l].payload.doc.data().contact_id == this.contactList2[k].id){
                    contactAppointment.push(this.appointmentList[l].payload.doc.data());            
                  }
                }
                
                this.contactList2[k].appointmentList = contactAppointment;
              }
      
            },err=>{
              this.isLoading = false;
              this._common.showLoader(false);
              this._alert.error(err.error && err.error.message?err.error.message:'Something went wrong!');
            }) */

            // fetch reminder list...
            /*this._lead.getReminderList({contactId: contactIdAll}).subscribe(result2=>{
                this.reminderList = result2;
      
                for (let k=0;k<this.contactList2.length;k++){
                  
                  //bind reminder list with contct list
                  let contactReminder = [];
                  for(let l=0; l<this.reminderList.length;l++){
                    if(this.reminderList[l].payload.doc.data().contact_id!==null && this.reminderList[l].payload.doc.data().contact_id == this.contactList2[k].id){
                      contactReminder.push(this.reminderList[l].payload.doc.data());            
                    }
                  }
                  this.contactList2[k].reminderList = contactReminder;
                }
      
              },err=>{
                this.isLoading = false;
                this._common.showLoader(false);
                this._alert.error(err.error && err.error.message?err.error.message:'Something went wrong!');
              }) */
            // fetch notes list...
            /* this._lead.getNotesList({contactId: contactIdAll}).subscribe(result3=>{
                  this._common.showLoader(false);
                  this.noteList = result3;
                  
                  for (let k=0;k<this.contactList2.length;k++){
                  
                    //bind notes list with contct list
                    let contactNotes = [];
                    for(let m=0; m<this.noteList.length;m++){
                      if(this.noteList[m].payload.doc.data().contact_id!==null && this.noteList[m].payload.doc.data().contact_id == this.contactList2[k].id){
                        contactNotes.push(this.noteList[m].payload.doc.data());            
                      }
                    }
                    this.contactList2[k].notesList = contactNotes;
                  }

                },err=>{
                  this.isLoading = false;
                  this._common.showLoader(false);
                  this._alert.error(err.error && err.error.message?err.error.message:'Something went wrong!');
                }) */

            // for(let m=0; m<this.contactList2.length; m++){
            //   this.contactList.push(this.contactList2[m]);
            // }

            // this.loadAppointmentReminderNotes(contactIdAll,this.pageCounter);
            // fetch appointment list
            /*
            this._lead.getAppointmentList({contactId: contactIdAll}).subscribe(result=>{
              this.appointmentList = result;
              // fetch reminder list...
              this._lead.getReminderList({contactId: contactIdAll}).subscribe(result2=>{
                this.reminderList = result2;
                // fetch notes list...
                this._lead.getNotesList({contactId: contactIdAll}).subscribe(result3=>{
                  this._common.showLoader(false);              

                  this.noteList = result3;
                  for (let k=0;k<this.contactList2.length;k++){
                    // Push client project list
                    const currentContactProject = this.clientProjectList.filter(item=>item.contact_id==this.contactList2[k].id);
                    if(this.contactList[k]){
                      this.contactList[k].projects = currentContactProject;
                    }
                    // bind appointment list with contact list
                    
                    let contactAppointment = [];
                    for(let l=0; l<this.appointmentList.length;l++){
                      if(this.appointmentList[l].payload.doc.data().contact_id!==null && this.appointmentList[l].payload.doc.data().contact_id == this.contactList2[k].id){
                        contactAppointment.push(this.appointmentList[l].payload.doc.data());            
                      }
                    }
                    // obj.appointmentList = contactAppointment;
                    this.contactList2[k].appointmentList = contactAppointment;
                    //bind reminder list with contct list
                    let contactReminder = [];
                    for(let l=0; l<this.reminderList.length;l++){
                      if(this.reminderList[l].payload.doc.data().contact_id!==null && this.reminderList[l].payload.doc.data().contact_id == this.contactList2[k].id){
                        contactReminder.push(this.reminderList[l].payload.doc.data());            
                      }
                    }
                    // obj.reminderList = contactReminder;
                    this.contactList2[k].reminderList = contactReminder;
                    //bind notes list with contct list
                    let contactNotes = [];
                    for(let m=0; m<this.noteList.length;m++){
                      if(this.noteList[m].payload.doc.data().contact_id!==null && this.noteList[m].payload.doc.data().contact_id == this.contactList2[k].id){
                        contactNotes.push(this.noteList[m].payload.doc.data());            
                      }
                    }
                    // obj.notesList = contactNotes;
                    this.contactList2[k].notesList = contactNotes;
                    this.contactList.push(this.contactList2[k]);
                  }
                  this.isLoading = false;
                },err=>{
                  this.isLoading = false;
                  this._common.showLoader(false);
                  this._alert.error(err.error && err.error.message?err.error.message:'Something went wrong!');
                })

              },err=>{
                this.isLoading = false;
                this._common.showLoader(false);
                this._alert.error(err.error && err.error.message?err.error.message:'Something went wrong!');
              })
            

            },err=>{
              this.isLoading = false;
              this._common.showLoader(false);
              this._alert.error(err.error && err.error.message?err.error.message:'Something went wrong!');
            }) */
            /*          },err=>{
            this.isLoading = false;
            this._common.showLoader(false);
            this._alert.error(err.error && err.error.message?err.error.message:'Something went wrong!');
          })*/

            this.pagination_clicked_count++;

            this.push_prev_startAt(this.firstInResponse);
            // if(this.totalContacts<=(this.pagination_clicked_count+1)*this.limit){
            //   this.disable_next = true;
            // }
            // else{
            //   this.disable_next = false;
            // }
            this.disable_next = false;
          },
          (error) => {
            this.isLoading = false;
            this.disable_next = false;
          }
        );
    }
  }

  showDetailData(id) {
    if (this.currentContactId !== id) {
      this.currentContactId = id;
      this.subscription3 = this._admin.getClientProjectList(id).subscribe(
        (result) => {
          this.clientProjectList = result.map((item) =>
            item.payload.doc.data()
          );

          // Load Appointments...
          this.subscription4 = this._lead
            .getAppointmentList({contactId: id})
            .subscribe(
              (result) => {
                this.appointmentList = result;
              },
              (err) => {
                this.isLoading = false;
                this._common.showLoader(false);
                this._alert.error(
                  err.error && err.error.message
                    ? err.error.message
                    : "Something went wrong!"
                );
              }
            );

          // fetch reminder list...
          this.subscription5 = this._lead
            .getReminderList({contactId: id})
            .subscribe(
              (result2) => {
                this.reminderList = result2;
              },
              (err) => {
                this.isLoading = false;
                this._common.showLoader(false);
                this._alert.error(
                  err.error && err.error.message
                    ? err.error.message
                    : "Something went wrong!"
                );
              }
            );
          // fetch notes list...
          this.subscription6 = this._lead
            .getNotesList({contactId: id})
            .subscribe(
              (result3) => {
                this._common.showLoader(false);
                this.noteList = result3;
              },
              (err) => {
                this.isLoading = false;
                this._common.showLoader(false);
                this._alert.error(
                  err.error && err.error.message
                    ? err.error.message
                    : "Something went wrong!"
                );
              }
            );
        },
        (err) => {
          this.isLoading = false;
          this._common.showLoader(false);
          this._alert.error(
            err.error && err.error.message
              ? err.error.message
              : "Something went wrong!"
          );
        }
      );
    }
  }

  //loadAppointmentReminderNotes

  loadAppointmentReminderNotes(contactIdAll, counter) {
    const starter = counter >= 1 ? counter * 10 - 1 : 0;
    // fetch appointment list

    this.subscription7 = this._lead
      .getAppointmentList({contactId: contactIdAll})
      .subscribe(
        (result) => {
          this.appointmentList = result;
          for (let k = starter; k < this.contactList.length; k++) {
            // Push client project list
            const currentContactProject = this.clientProjectList.filter(
              (item) => item.contact_id == this.contactList[k].id
            );
            this.contactList[k].projects = currentContactProject;
            // bind appointment list with contact list
            let contactAppointment = [];

            for (let l = 0; l < this.appointmentList.length; l++) {
              if (
                this.appointmentList[l].payload.doc.data().contact_id !==
                  null &&
                this.appointmentList[l].payload.doc.data().contact_id ==
                  this.contactList[k].id
              ) {
                contactAppointment.push(
                  this.appointmentList[l].payload.doc.data()
                );
              }
            }

            this.contactList[k].appointmentList = contactAppointment;
          }
        },
        (err) => {
          this.isLoading = false;
          this._common.showLoader(false);
          this._alert.error(
            err.error && err.error.message
              ? err.error.message
              : "Something went wrong!"
          );
        }
      );

    // fetch reminder list...
    this.subscription8 = this._lead
      .getReminderList({contactId: contactIdAll})
      .subscribe(
        (result2) => {
          this.reminderList = result2;

          for (let k = starter; k < this.contactList.length; k++) {
            //bind reminder list with contct list
            let contactReminder = [];
            for (let l = 0; l < this.reminderList.length; l++) {
              if (
                this.reminderList[l].payload.doc.data().contact_id !== null &&
                this.reminderList[l].payload.doc.data().contact_id ==
                  this.contactList[k].id
              ) {
                contactReminder.push(this.reminderList[l].payload.doc.data());
              }
            }
            this.contactList[k].reminderList = contactReminder;
          }
        },
        (err) => {
          this.isLoading = false;
          this._common.showLoader(false);
          this._alert.error(
            err.error && err.error.message
              ? err.error.message
              : "Something went wrong!"
          );
        }
      );
    // fetch notes list...
    this.subscription9 = this._lead
      .getNotesList({contactId: contactIdAll})
      .subscribe(
        (result3) => {
          this._common.showLoader(false);
          this.noteList = result3;

          for (let k = starter; k < this.contactList.length; k++) {
            //bind notes list with contct list
            let contactNotes = [];
            for (let m = 0; m < this.noteList.length; m++) {
              if (
                this.noteList[m].payload.doc.data().contact_id !== null &&
                this.noteList[m].payload.doc.data().contact_id ==
                  this.contactList[k].id
              ) {
                contactNotes.push(this.noteList[m].payload.doc.data());
              }
            }
            this.contactList[k].notesList = contactNotes;
          }
          this.isLoading = false;
          // if(window.screen.height>900 && counter==0){
          //   this.nextPage();
          // }
        },
        (err) => {
          this.isLoading = false;
          this._common.showLoader(false);
          this._alert.error(
            err.error && err.error.message
              ? err.error.message
              : "Something went wrong!"
          );
        }
      );
  }

  //Remove not required document
  pop_prev_startAt(prev_first_doc) {
    this.prev_strt_at.forEach((element) => {
      if (prev_first_doc && prev_first_doc.data().id == element.data().id) {
        element = null;
      }
    });
  }

  //Return the Doc rem where previous page will startAt
  get_prev_startAt() {
    if (this.prev_strt_at.length > this.pagination_clicked_count + 1)
      this.prev_strt_at.splice(
        this.prev_strt_at.length - 2,
        this.prev_strt_at.length - 1
      );
    return this.prev_strt_at[this.pagination_clicked_count - 1];
  }

  // get job function list...
  getJobFunctionList() {
    this._common.showLoader(true);
    this.subscription10 = this._admin.getJobFunctionList().subscribe(
      (result) => {
        for (let item of result) {
          this.jobFunctionList.push({
            name: item.payload.doc.data()["name"],
            id: item.payload.doc.id,
            selected: false,
          });
        }
      },
      (err) => {
        // this._common.showLoader(false);
        this._alert.error(
          err.error && err.error.message
            ? err.error.message
            : "Something went wrong!"
        );
      }
    );
  }

  openAddLeadDialog(modalType) {
    this.dialog.open(AddLeadDialogComponent, {
      width: "auto",
      data: {
        modalType: modalType,
      },
    });
  }

  openEditContactDialog(id) {
    this._lead
      .getContactDetail2(id)
      .then((res: any) => {
        const data = res.payload.data();

        let dialogRef = this.dialog.open(EditContactDialogComponent, {
          width: "auto",
          data: {
            id: id,
            jobFunctionList: this.jobFunctionList,
            contactData: data,
          },
        });

        dialogRef.afterClosed().subscribe((response) => {
          // this.getUserList(localStorage.getItem('uid'))
        });
      })
      .catch((err) => {
        this.errMsg =
          err.error && err.error.message
            ? err.error.message
            : "Something went wrong!";
      });
  }

  checkArray(item: any) {
    return Array.isArray(item);
  }

  deleteLead(id) {
    this._common.showLoader(true);

    this._lead
      .deleteLead(id)
      .then((res) => {
        this.subscription11 = this._lead.deleteLeadProject(id).subscribe(
          (res2) => {
            index
              .deleteObjects([id])
              .then(({objectIDs}) => {
                this.successMsg = "Contact deleted successfully!";
              })
              .catch((err) => {
                this.errMsg =
                  "Something went wrong while updating over Algolia";
              });
          },
          (err) => {
            this.errMsg =
              err.error && err.error.message
                ? err.error.message
                : "Something went wrong!";
          }
        );
      })
      .catch((err) => {
        this.errMsg =
          err.error && err.error.message
            ? err.error.message
            : "Something went wrong!";
      });
  }

  // open add appointment dialog
  openAddAppointmentDialog(id) {
    this.successMsg = "";
    this.errMsg = "";
    this.dialog.open(AddAppointmentDialogComponent, {
      width: "auto",
      data: {
        contact_id: id,
        category: "contact",
      },
    });
  }
  // Add open reminder dialog
  openAddReminderDilaog(id, owner_contact_id) {
    this.successMsg = "";
    this.errMsg = "";
    this.dialog.open(AddReminderDialogComponent, {
      width: "auto",
      data: {
        contact_id: id,
        owner_contact_id: owner_contact_id,
        category: "contact",
      },
    });
  }

  // add note dialog
  openAddNoteDilaog(id) {
    this.successMsg = "";
    this.errMsg = "";
    this.dialog.open(AddNoteDialogComponent, {
      width: "auto",
      data: {
        contact_id: id,
        category: "contact",
      },
    });
  }

  // get designer list...
  getDesignerList() {
    this._common.showLoader(true);
    const listType = filterEmailList.includes(localStorage.getItem("rs-email"))
      ? "all"
      : localStorage.getItem("uid");
    this.subscription12 = this._lead.getDesignerList(listType).subscribe(
      (result) => {
        this._common.showLoader(false);
        this.designerList = result;
      },
      (error) => {
        this._common.showLoader(false);
        this._alert.error("Something went wrong");
      }
    );
  }

  // get contact source list
  getcontactSourceList() {
    this._common.showLoader(true);
    this.subscription13 = this._admin.getContactSourceList().subscribe(
      (result) => {
        this._common.showLoader(false);
        this.contactSourceList = result;
      },
      (error) => {
        this._common.showLoader(false);
        this._alert.error("Something went wrong");
      }
    );
  }

  // get showroom list...
  getShowroomList() {
    this._common.showLoader(true);
    this.subscription14 = this._admin.geShowroomList().subscribe(
      (result) => {
        this._common.showLoader(false);
        this.showrooms = result;
      },
      (error) => {
        this._common.showLoader(false);
        this._alert.error("Something went wrong");
      }
    );
  }

  // Check showroom
  checkShowroom(showroom) {
    if (!emailList.includes(localStorage.getItem("rs-email"))) {
      this.subscription12 = this._lead
        .getDesignerList(localStorage.getItem("uid"))
        .subscribe(
          (result) => {
            const showrooms = result[0].payload.doc.data()["showroom"];
            let showroomIndex = showrooms.findIndex(
              (item) => item.showroom_id === showroom.split(",")[0]
            );
            if (showroomIndex === -1) {
              this._toastr.error(`Please select showroom which you owns`, "", {
                timeOut: 4000,
              });
              this.filterForm.patchValue({showroom: null});
              return false;
            }
          },
          (err) => {
            this._alert.error(err.message);
          }
        );
    }
  }

  openAddProjectDialog(
    client_id,
    owner_contact_id,
    first_name,
    last_name,
    address,
    showroom
  ) {
    this.dialog.open(AddProjectDialogComponent, {
      width: "auto",
      data: {
        client_id: client_id,
        owner_contact_id: owner_contact_id,
        address: address,
        first_name,
        last_name,
        source: "contact",
        showroom_id:
          showroom && showroom.length > 0 ? showroom[0].showroom_id : "",
        modalSource: "contact",
      },
    });
  }

  createTab(contact_id, first_name, last_name) {
    this._common.showLoader(true);
    // Check if the current contact is already saved for this user id
    // this._admin.checkContactTab(contact_id, localStorage.getItem('uid')).subscribe(resp=>{
    // if(resp.length==0){
    const obj = {
      id: this.firestore.createId(),
      contact_id: contact_id,
      contact_name: first_name + " " + last_name,
      author_contact_id: localStorage.getItem("contactId"),
      author_user_id: localStorage.getItem("uid"),
      date_created: Date.now(),
    };

    this._admin
      .createContactTab(obj.id, obj)
      .then((res2) => {
        this._common.showLoader(false);
        this._toastr.success(`Tab created successfully!`, "", {timeOut: 4000});
      })
      .catch((err) => {
        this._common.showLoader(false);
        this._toastr.error(`Something went wrong!`, "", {timeOut: 4000});
      });
    // }
    // else {
    //   this._common.showLoader(false);
    //   this._toastr.error(`Tab already added`,"",{ timeOut: 4000 });
    // }
    // },err=>{
    //   this._common.showLoader(false);
    //   this._toastr.error(`Something went wrong!`,"",{ timeOut: 4000 });
    // })
  }

  resendEmail(data) {
    if (data.contact_type_id === "lead" || data.contact_type_id === "client") {
      this._common.showLoader(true);
      this._project.getSystemMode().subscribe(
        (system) => {
          const systemData = system.map((item) => item.payload.doc.data());
          const arr: any = systemData.filter((item) =>
            item.hasOwnProperty("email_system_wide")
          );
          const baseUrlObj: any = systemData.filter((item) =>
            item.hasOwnProperty("base_url")
          );
          if (arr && arr[0].email_system_wide === "Enabled") {
            // Fetch Showroom data
            let showroomData: any = {};
            // if(data.showroom_default_id){
            // this._admin.getShowroomDetail(data.showroom_default_id).subscribe(res=>{
            // showroomData = res.payload.data();
            // if(showroomData){
            // Send email..

            let to = "rs@leichtnewyork.com";
            let cc =
              "gs@gregorysmith.ws,mayan@leichtnewyork.com,nurit@leichtnewyork.com";
            let contactTypeName;
            if (data.contact_type_id === "lead") {
              contactTypeName = "Lead";
              /*     if(showroomData.email_alert_lead_creation && showroomData.email_alert_lead_creation.length==1){
                        to =showroomData.email_alert_lead_creation.join(',');
                      }
                      else if(showroomData.email_alert_lead_creation && showroomData.email_alert_lead_creation.length>1){
                        to =showroomData.email_alert_lead_creation[0];
                        let tempArr = showroomData.email_alert_lead_creation;
                        tempArr.shift();
                        cc = tempArr.join(',');
                      }
                      else {
                        to = '';
                      }*/
            } else {
              contactTypeName = "Client";
              /* if(showroomData.email_alert_client_creation && showroomData.email_alert_client_creation.length==1){
                        to =showroomData.email_alert_client_creation.join(',');
                      }
                      else if(showroomData.email_alert_client_creation && showroomData.email_alert_client_creation.length>1){
                        to =showroomData.email_alert_client_creation[0];
                        let tempArr = showroomData.email_alert_client_creation;
                        tempArr.shift();
                        cc = tempArr.join(',');
                      }
                      else {
                        to = '';
                      }*/
            }
            const subject = `New ${contactTypeName} Created - ${data.first_name} ${data.last_name} - ${data.id}`;
            const html = `Added By: ${data.owner_first_name} ${
              data.owner_last_name
            }<br/>Name: ${data.first_name} ${
              data.last_name
            }<br/>Type: ${contactTypeName}<br/>Mobile Phone: ${
              data.mobile_phone || ""
            }<br/>Main Phone: ${data.main_phone || ""}<br/>Work Phone: ${
              data.work_phone || ""
            }<br/>Fax: ${data.fax || ""}<br/>Source: ${
              data.contact_source_name || ""
            }<br/>Notes: ${data.notes}<br/>Address: ${
              data.address || ""
            }<br/>Company: ${data.company || ""}<br/><br/>Account: ${
              baseUrlObj[0].base_url
            }contact/${data.id}<br/>-<br/>Automated email sent via RS`;
            const mailBody = {
              to: to,
              from: "rs@leichtnewyork.com", // from
              subject: subject,
              body: html,
              cc: cc,
            };
            this._project.initEmail(mailBody).subscribe(
              (res) => {
                if (res) {
                  this._common.showLoader(false);
                  this._toastr.success(`Mail sent Successfully!`, "", {
                    timeOut: 5000,
                  });
                }
              },
              (err) => {
                this._common.showLoader(false);
                const errMsg =
                  err && err.message ? err.message : "Something went wrong!";
                this._toastr.success(errMsg, "", {timeOut: 5000});
              }
            );
            // }
            // })
            // }
          }
        },
        (err) => {
          this._common.showLoader(false);
          const errMsg =
            err && err.message ? err.message : "Something went wrong!";
          this._toastr.success(errMsg, "", {timeOut: 5000});
        }
      );
    }
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
    if (this.subscription2) this.subscription2.unsubscribe();
    if (this.subscription3) this.subscription3.unsubscribe();
    if (this.subscription4) this.subscription4.unsubscribe();
    if (this.subscription5) this.subscription5.unsubscribe();
    if (this.subscription6) this.subscription6.unsubscribe();
    if (this.subscription7) this.subscription7.unsubscribe();
    if (this.subscription8) this.subscription8.unsubscribe();
    if (this.subscription9) this.subscription9.unsubscribe();
    if (this.subscription10) this.subscription10.unsubscribe();
    if (this.subscription11) this.subscription11.unsubscribe();
    if (this.subscription12) this.subscription12.unsubscribe();
    if (this.subscription13) this.subscription13.unsubscribe();
    if (this.subscription14) this.subscription14.unsubscribe();
  }
}
